import CheckInCustomization from './CheckInCustomization';

export default CheckInCustomization;
